export default "__VITE_ASSET__oz6pYEqG__"